import { render } from "./ChangeHistory.vue?vue&type=template&id=35b441d1&scoped=true"
import script from "./ChangeHistory.vue?vue&type=script&lang=js"
export * from "./ChangeHistory.vue?vue&type=script&lang=js"

import "./ChangeHistory.vue?vue&type=style&index=0&id=35b441d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b441d1"]])

export default __exports__